import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
@Component({
  selector: 'app-transfer-batch-table',
  templateUrl: './transfer-batch-table.component.html',
  styleUrls: ['./transfer-batch-table.component.scss']
})
export class TransferBatchTableComponent implements OnInit {
  @Input() resultsPerPage: number = 10;
  @Input() tableHeaders: any;
  @Input() tableRows: any;
  @Output() editTableItem = new EventEmitter<any>();
  @Output() deleteTableItem = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onEdit(rowId: string): void {
    this.editTableItem.emit(rowId);
  }

  onDelete(data: any): void {
    if (this.disableDeleteButton(data)) { return; }
    this.deleteTableItem.emit(data.id);
  }

  disableDeleteButton(data: any): boolean {
    return data.tr[11].display;
  }
}
